import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialDetailComponent } from './material-detail.component';
import { CoreModule } from 'app/core/core.module';

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
  ],
  declarations: [MaterialDetailComponent],
  entryComponents: [MaterialDetailComponent]
})
export class MaterialDetailModule { }
